<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Masraf Merkezine Göre Hesap Ekstresi</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>







            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>

              <v-flex xs12 sm6 md6 style="padding-right:2px;padding-bottom:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ currentDebtTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ currentCreditTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Cari Dönem </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ debtTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ creditTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Genel Toplam </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

            </v-layout>

            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-select :items="MasrafMerkezi" clearable :rules="[v => !!v || 'Lütfen masraf merkezi seçiniz']"
                      label="Masraf Merkezi Seçiniz.." v-model="EkstreHesap.Masraf.Code" item-text="text" item-value="id">
                    </v-select>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>


                  <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
                    <v-card color="grey lighten-2">

                      <v-card-title>Filtre Seçimi</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>

                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>
                            <v-autocomplete clearable="" label="Cari Kodu Seçiniz" append-icon="search" :loading="loading"
                              :items="statecari" item-text="text" cache-items="" item-value="id" v-model="EkstreHesap.Cari.Kod"
                              :search-input.sync="searchcari"></v-autocomplete>
                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                              </v-card-title>
                            </v-card>
                            <v-radio-group hide-details="" label="Rapor Şekli" v-model="EkstreHesap.RaporTip" column>
                              <v-radio label="Sadece Girilen Masraf Merkezi" value="0">
                              </v-radio>
                              <v-radio label="Girilen Masraf Merkezi İle Başlayanlar" value="1"></v-radio>
                              <v-radio label="İçinde Girilen Masraf Merkezi Geçenler" value="2"></v-radio>
                            </v-radio-group>

                            <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>


                          </v-layout>
                        </v-flex>

                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-flex xs12 sm12 md12>
                    <v-card>
                      <v-card-title>
                        <v-spacer></v-spacer>

                      </v-card-title>
                      <v-data-table :headers="headers" :loading="progress" :items="items" :search="search3">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.Date }}</td>
                          <td class="text-xs-left">{{ props.item.Current }}</td>
                          <td class="text-xs-left">{{ props.item.DocumentType }}</td>
                          <td class="text-xs-left">{{ props.item.DocumentNumber}}</td>
                          <td class="text-xs-left">{{ props.item.Explanation}}</td>
                          <td class="text-xs-left">{{ props.item.DueDate }}</td>
                          <td class="text-xs-right">{{ props.item.Debt | moneyformat}}</td>
                          <td class="text-xs-right">{{ props.item.Credit | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.Balance | bakiyekontrol }}</td>
                          <td class="text-xs-left">{{ props.item.BAType }}</td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                        </v-alert>
                      </v-data-table>
                    </v-card>

                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                      {{ text1 }}
                      <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                    </v-snackbar>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'

  export default {
    data() {
      return {
        search: '',
        valid: true,
        headers: [{
            text: 'Tarih',
            value: 'Date'
          },
          {
            text: 'Cari Kod',
            value: 'Current'
          },
          {
            text: 'Evrak Tipi',
            value: 'DocumentType'
          },
          {
            text: 'Evrak No',
            value: 'DocumentNumber'
          },
          {
            text: 'Açıklama',
            value: 'Explanation'
          },
          {
            text: 'Vade Tarihi',
            value: 'DueDate'
          },
          {
            text: 'Borç',
            value: 'Debt',
            align: 'right'
          },
          {
            text: 'Alacak',
            value: 'Credit',
            align: 'right'
          },
          {
            text: 'Bakiye',
            value: 'Balance',
            align: 'right'
          },
          {
            text: 'B/A',
            value: 'BAType'
          }
        ],
        EkstreHesap: {

          SirketKodu: '',
          Masraf: {
            Code: ''
          },
          BaslangicTarih: '',
          BitisTarih: '',
          Cari: {
            Kod: ''
          },
          RaporTip: '0'

        },
        currentDebtTotal: 0,
        currentCreditTotal: 0,
        debtTotal: 0,
        creditTotal: 0,
        StartDate: null,
        EndDate: null,
        statecari: [],
        MasrafMerkezi: [],
        searchcari: '',
        dictionary: {
          custom: {
            masrafkodu: {
              required: () => 'Lütfen seçiminizi yapınız'
            },
            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        evraktipi: [],
        anahesap: [],
        tumsirketler: '',

        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        progress: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },
    methods: {

      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,

      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir
    }
  }


  function filtrele() {
    this.dialogfiltre = true
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.progress = false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }



  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false
    this.EkstreHesap.Cari.Kod = null
    this.EkstreHesap.RaporTip = "0"
    this.tumsirketler = false

  }


  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function getList() {


    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {
        this.progress = true
        this.currentDebtTotal = 0
        this.currentCreditTotal = 0
        this.debtTotal = 0
        this.creditTotal = 0


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.EkstreHesap.SirketKodu = '0'
        } else {
          this.EkstreHesap.SirketKodu = credentials.SirketKodu
        }

        this.EkstreHesap.BaslangicTarih = this.date
        this.EkstreHesap.BitisTarih = this.date2

        var params = this.EkstreHesap

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithExpenseCenter', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body.List
          this.text1 = 'toplam ' + response.body.List.length + ' kayıt bulundu..'
          this.snackbar = true
          // this.currentDebtTotal = response.body.DonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.currentCreditTotal = response.body.DonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.debtTotal = response.body.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.creditTotal = response.body.ToplamAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.currentDebtTotal = response.body.DonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
            '$1,')
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }

  function getListHtml() {

    this.progress = true
    this.currentDebtTotal = 0
    this.currentCreditTotal = 0
    this.debtTotal = 0
    this.creditTotal = 0



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.EkstreHesap.SirketKodu = '0'
    } else {
      this.EkstreHesap.SirketKodu = credentials.SirketKodu
    }

    this.EkstreHesap.BaslangicTarih = this.date
    this.EkstreHesap.BitisTarih = this.date2



    var params = this.EkstreHesap


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithExpenseCenterHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "MasrafEkstre.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }


  function getListExcel() {

    this.progress = true
    this.currentDebtTotal = 0
    this.currentCreditTotal = 0
    this.debtTotal = 0
    this.creditTotal = 0

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.EkstreHesap.SirketKodu = '0'
    } else {
      this.EkstreHesap.SirketKodu = credentials.SirketKodu
    }

    this.EkstreHesap.BaslangicTarih = this.date
    this.EkstreHesap.BitisTarih = this.date2



    var params = this.EkstreHesap


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithExpenseCenterExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "MasrafEkstre.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }


  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Options/ExpenseCenters', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.MasrafMerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })
  }
</script>
<style>
</style>